import { render, staticRenderFns } from "./second-header.vue?vue&type=template&id=2e2b6ab6&"
import script from "./second-header.vue?vue&type=script&lang=js&"
export * from "./second-header.vue?vue&type=script&lang=js&"
import style0 from "./second-header.vue?vue&type=style&index=0&id=2e2b6ab6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports